/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * The review status of the caller's own professional profile, whichever mode they are in; `none` when they have none. Only `approved` places activities at a Hub
 */
export enum HubViewerProfileStatus {
  none = 'none',
  incomplete = 'incomplete',
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected'
}
